"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var Status;

(function (Status) {
  Status["ENTERING"] = "ENTERING";
  Status["ENTERED"] = "ENTERED";
  Status["EXITING"] = "EXITING";
  Status["EXITED"] = "EXITED";
})(Status = exports.Status || (exports.Status = {}));

var WillEnter =
/** @class */
function (_super) {
  __extends(WillEnter, _super);

  function WillEnter(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      status: Status.EXITED
    };

    _this.onEntering = function () {
      _this.setState({
        status: Status.ENTERING
      });
    };

    _this.onEntered = function () {
      _this.setState({
        status: Status.ENTERED
      });
    };

    _this.onExiting = function () {
      _this.setState({
        status: Status.EXITING
      });
    };

    _this.onExited = function () {
      _this.setState({
        status: Status.EXITED
      });
    };

    _this.timer = typeof _this.props['timer'] === 'number' ? _this.props['timer'] : 100;
    return _this;
  }

  WillEnter.prototype.componentWillReceiveProps = function (props) {
    this.handleUpdate(props);
  };

  WillEnter.prototype.componentWillUnmount = function () {
    clearTimeout(this.timerId);
  };

  WillEnter.prototype.handleUpdate = function (props) {
    var _this = this;

    if (props.active) {
      this.onEntering();
    } else {
      this.onExiting();
    }

    clearTimeout(this.timerId);
    this.timerId = setTimeout(function () {
      if (props.active) {
        _this.onEntered();
      } else {
        _this.onExited();
      }
    }, props.timer);
  };

  return WillEnter;
}(react_1.Component);

exports.default = WillEnter;